import React from 'react';

export default function PurposeLaneCard({ glyph, title, desc }) {
  return (
    <div className="purpose-lane-card">
      <span className="lane-glyph">{glyph}</span>
      <strong>{title}</strong>
      <p>{desc}</p>
    </div>
  );
}